import { render, staticRenderFns } from "./LeaveAdminHeader.vue?vue&type=template&id=5bd68014"
import script from "./LeaveAdminHeader.ts?vue&type=script&lang=ts&external"
export * from "./LeaveAdminHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports